/* Atharn wall mockup — variant trimming, light matching, guided tour */
window.AtharMockupFx = (function () {
'use strict';
var SWATCH = { 'wood': '#c9a375', 'dark wood': '#4a3326', 'black': '#1d1d1d' };
function frameKey(n) { var k = String(n || '').toLowerCase().replace(/\s*frame\s*$/, '').trim(); return SWATCH[k] ? k : 'wood'; }
function parseSize(s) {
var m = String(s || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/i);
if (!m) return null;
var a = parseFloat(m[1].replace(',', '.')) * 10, b = parseFloat(m[2].replace(',', '.')) * 10;
return [Math.min(a, b), Math.max(a, b)];
}
function cmLabel(mm) { return (Math.round(mm) / 10).toString().replace(/\.0$/, ''); }
function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
var cache = {};
function trim(img) {
var key = img.currentSrc || img.src;
if (cache[key]) return cache[key];
var w = img.naturalWidth, h = img.naturalHeight;
var c = document.createElement('canvas'); c.width = w; c.height = h;
var x = c.getContext('2d'); x.drawImage(img, 0, 0);
var d;
try { d = x.getImageData(0, 0, w, h).data; } catch (e) { return (cache[key] = { url: key, ratio: w / h }); }
var rows = new Uint32Array(h), cols = new Uint32Array(w), i, yy, xx;
for (yy = 0; yy < h; yy++) for (xx = 0; xx < w; xx++) {
i = (yy * w + xx) * 4;
if (d[i + 3] > 20 && (d[i] < 236 || d[i + 1] < 236 || d[i + 2] < 236)) { rows[yy]++; cols[xx]++; }
}
var t = 0, b = h - 1, l = 0, r = w - 1, mw = w * 0.15, mh = h * 0.15;
while (t < h - 1 && rows[t] < mw) t++;
while (b > t && rows[b] < mw) b--;
while (l < w - 1 && cols[l] < mh) l++;
while (r > l && cols[r] < mh) r--;
if (r - l < w * 0.2 || b - t < h * 0.2) { t = 0; l = 0; r = w - 1; b = h - 1; }
var o = document.createElement('canvas'); o.width = r - l + 1; o.height = b - t + 1;
o.getContext('2d').drawImage(c, l, t, o.width, o.height, 0, 0, o.width, o.height);
return (cache[key] = { url: o.toDataURL('image/jpeg', 0.92), ratio: o.width / o.height, canvas: o });
}
var S = null;
function sample(photo) {
var w = 240, h = Math.max(1, Math.round(photo.naturalHeight * 240 / photo.naturalWidth));
var c = document.createElement('canvas'); c.width = w; c.height = h;
var x = c.getContext('2d'); x.drawImage(photo, 0, 0, w, h);
try { S = { w: w, h: h, d: x.getImageData(0, 0, w, h).data }; } catch (e) { S = null; }
}
function measure(box, dw) {
if (!S) return null;
var k = S.w / dw, bw = box.x1 - box.x0, bh = box.y1 - box.y0, cx = (box.x0 + box.x1) / 2;
var x0 = box.x0 - bw * 0.35, x1 = box.x1 + bw * 0.35, y0 = box.y0 - bh * 0.25, y1 = box.y1 + bh * 0.25;
var R = 0, G = 0, B = 0, n = 0, sl = 0, nl = 0, sr = 0, nr = 0;
for (var y = Math.max(0, Math.floor(y0 * k)); y < Math.min(S.h, y1 * k); y++) {
for (var x = Math.max(0, Math.floor(x0 * k)); x < Math.min(S.w, x1 * k); x++) {
var X = x / k, Y = y / k;
if (X > box.x0 && X < box.x1 && Y > box.y0 && Y < box.y1) continue;
var i = (y * S.w + x) * 4, L = (0.2126 * S.d[i] + 0.7152 * S.d[i + 1] + 0.0722 * S.d[i + 2]) / 255;
R += S.d[i]; G += S.d[i + 1]; B += S.d[i + 2]; n++;
if (X < cx) { sl += L; nl++; } else { sr += L; nr++; }
}
}
if (n < 20) return null;
R /= n; G /= n; B /= n;
var Lm = (0.2126 * R + 0.7152 * G + 0.0722 * B) / 255;
var left = nl ? sl / nl : Lm, right = nr ? sr / nr : Lm;
return { r: R, g: G, b: B, L: Lm, side: (right - left) / Math.max(Lm, 0.05) };
}
function look(m) {
if (!m) return { k: 1, tint: [255, 255, 255], alpha: 0, side: 0, dark: 0.3 };
var mx = Math.max(m.r, m.g, m.b, 1);
return {
k: Math.max(0.45, Math.min(1.06, m.L / 0.78)),
tint: [Math.round(255 * m.r / mx), Math.round(255 * m.g / mx), Math.round(255 * m.b / mx)],
alpha: 0.45,
side: Math.max(-1, Math.min(1, m.side * 3)),
dark: Math.min(0.6, 0.24 + (1 - m.L) * 0.4)
};
}
function rgb(a) { return 'rgb(' + a.join(',') + ')'; }
function gradient(P) {
var a = Math.abs(P.side) * 0.14 + 0.03;
return 'linear-gradient(' + (P.side >= 0 ? 'to left' : 'to right') + ',rgba(255,248,235,' + a.toFixed(3) + '),rgba(0,0,0,' + (a * 0.9).toFixed(3) + '))';
}
function shadow(P) {
return (-P.side * 28).toFixed(1) + 'px 22px 46px rgba(0,0,0,' + P.dark.toFixed(2) + '),' + (-P.side * 4).toFixed(1) + 'px 4px 8px rgba(0,0,0,' + (P.dark * 0.9).toFixed(2) + ')';
}
function styleDom(frame, img, tintEl, lightEl, P) {
img.style.filter = P.k < 0.995 || P.k > 1.005 ? 'brightness(' + P.k.toFixed(3) + ')' : '';
tintEl.style.background = rgb(P.tint);
tintEl.style.opacity = P.alpha;
lightEl.style.background = gradient(P);
frame.style.boxShadow = shadow(P);
}
function paint(ctx, w, h, P) {
ctx.save();
ctx.globalCompositeOperation = 'multiply';
if (P.k < 1) { var g = Math.round(255 * P.k); ctx.fillStyle = rgb([g, g, g]); ctx.fillRect(0, 0, w, h); }
ctx.globalAlpha = P.alpha; ctx.fillStyle = rgb(P.tint); ctx.fillRect(0, 0, w, h);
ctx.restore();
ctx.save();
var a = Math.abs(P.side) * 0.14 + 0.03, gr = ctx.createLinearGradient(P.side >= 0 ? w : 0, 0, P.side >= 0 ? 0 : w, 0);
gr.addColorStop(0, 'rgba(255,248,235,' + a + ')'); gr.addColorStop(1, 'rgba(0,0,0,' + a * 0.9 + ')');
ctx.fillStyle = gr; ctx.fillRect(0, 0, w, h);
ctx.restore();
}
function tour(root, steps, done) {
steps = steps.filter(function (st) { var el = st.el(); return el && el.getClientRects().length && getComputedStyle(el).display !== 'none'; });
if (!steps.length) return;
var ov = document.createElement('div'); ov.className = 'am-tour';
ov.innerHTML = '<div class="am-spot"></div><div class="am-tip" role="dialog" aria-live="polite"><div class="am-tip-art"></div><p class="am-tip-en"></p><p class="am-tip-ar" dir="rtl" lang="ar"></p><div class="am-tip-row"><span class="am-dots"></span><button type="button" class="am-tip-next"></button></div></div>';
root.appendChild(ov);
var spot = ov.querySelector('.am-spot'), tip = ov.querySelector('.am-tip'), i = 0;
function place() {
var st = steps[i], r = st.el().getBoundingClientRect(), rr = root.getBoundingClientRect(), pad = st.pad || 8, art = tip.querySelector('.am-tip-art');
art.innerHTML = st.art || ''; art.hidden = !st.art;
var x = r.left - rr.left - pad, y = r.top - rr.top - pad, w = r.width + pad * 2, h = r.height + pad * 2;
spot.style.left = x + 'px'; spot.style.top = y + 'px'; spot.style.width = w + 'px'; spot.style.height = h + 'px';
tip.querySelector('.am-tip-en').textContent = st.en;
tip.querySelector('.am-tip-ar').textContent = st.ar;
tip.querySelector('.am-tip-next').textContent = i === steps.length - 1 ? 'Start · ابدأ' : 'Next · التالي';
tip.querySelector('.am-dots').innerHTML = steps.map(function (_, j) { return '<i' + (j === i ? ' class="on"' : '') + '></i>'; }).join('');
var vw = rr.width, vh = rr.height, tw = Math.min(320, vw - 24);
tip.style.width = tw + 'px';
var th = tip.offsetHeight, below = y + h + 14, top = below + th < vh - 10 ? below : Math.max(10, y - th - 14);
var left = Math.max(12, Math.min(vw - tw - 12, x + w / 2 - tw / 2));
tip.style.left = left + 'px'; tip.style.top = top + 'px';
tip.classList.toggle('is-above', top < y);
tip.style.setProperty('--ax', Math.max(18, Math.min(tw - 18, x + w / 2 - left)) + 'px');
}
function end() { ov.remove(); window.removeEventListener('resize', place); if (done) done(); }
ov.querySelector('.am-tip-next').addEventListener('click', function () { if (++i >= steps.length) end(); else place(); });
window.addEventListener('resize', place);
place();
}
var DOOR = '<svg viewBox="0 0 200 110" aria-hidden="true"><rect width="200" height="110" fill="#efe6d8"/><rect x="62" y="12" width="46" height="92" rx="2" fill="#a8835a"/><rect x="68" y="18" width="34" height="38" rx="2" fill="#b8936a"/><rect x="68" y="62" width="34" height="36" rx="2" fill="#b8936a"/><circle cx="100" cy="60" r="3" fill="#f3d9b8"/><path d="M128 12V104" stroke="#fff" stroke-width="3" stroke-dasharray="6 4"/><circle cx="128" cy="12" r="6" fill="#fff" stroke="#c2703d" stroke-width="3"/><circle cx="128" cy="104" r="6" fill="#fff" stroke="#c2703d" stroke-width="3"/><rect x="138" y="46" width="56" height="22" rx="11" fill="#3b3127"/><text x="166" y="61" text-anchor="middle" font-size="12" font-weight="700" fill="#fff" font-family="system-ui,sans-serif">210 cm</text></svg>';
return { DOOR: DOOR, tour: tour, SWATCH: SWATCH, frameKey: frameKey, parseSize: parseSize, cmLabel: cmLabel, uniq: uniq, trim: trim, sample: sample, measure: measure, look: look, styleDom: styleDom, paint: paint };
})();